import * as d3 from 'd3';
import * as moment from 'moment';

import { IDateTimePickerScope } from './DateTimePicker';

export interface IWtDateTimePicker extends ng.IDirective {
}

export interface IWtDateTimePickerScope extends ng.IScope {
}

export class WtDateTimePicker implements IWtDateTimePicker {
    static directiveId = 'wtDateTimePicker';
    restrict = 'E';
    templateUrl = 'wt-date-time-picker.html';
    controller = 'DateTimePicker';
    bindToController = true;
    controllerAs = 'vm';
    scope: any;
    replace = true;

    private _hourNeedle: d3.Selection<any>;
    private _minuteNeedle: d3.Selection<any>;
    private _size: number;
    day: number;

    constructor(private $window: ng.IWindowService) {
        this.scope = {
            date: '=?',
            placeholder: '@',
            title: '=?',
            change: '&?',
            name: '@',
            right: '@?',
            small: '@?'
        };
    }

    link = (scope: IDateTimePickerScope, element, attrs) => {
        const container = element[0];
        this._size = this.initCalendar(container);
        scope.vm.setProperties(this.scope);
    }

    private setContainerStyle(container): number {
        const containerWidth = container.width();
        const width = containerWidth;
        return width;
    }

    private initCalendar(container): number {
        const weekDaysHeight = 15;
        const weekNumberWidth = 30;
        const divContainer = $(container);
        this.setContainerStyle(divContainer);
        const cc = d3.select(container).select('.calendarContainer')[0];
        const divWidth = $(cc).width();

        const usableWidth = divWidth - weekNumberWidth - 7 * 2;
        const size = Math.max(Math.min(usableWidth / 7, 50), 25);
        this.scope.size = size;
        const width = '100%';
        const height = size * 6 + weekDaysHeight + 7 * 2;

        this.scope.selection = d3.select(container);
        const calendar = this.scope.selection
            .select('.calendar')
            .append('svg')
            .attr({
                'width': width,
                'height': height
            }).append('g')
            .classed('date-time-picker', true);

        calendar.append('g')
            .classed('weekNumbers', true)
            .attr({
                'transform': 'translate(' + 5 + ',' + (weekDaysHeight / 2) + ')'
            });

        calendar.append('g')
            .classed('dates', true)
            .attr({
                'transform': 'translate(' + weekNumberWidth + ',' + (weekDaysHeight + 2) + ')'
            });

        const weekDaysGroup = calendar.append('g')
            .classed('weekdays', true)
            .attr({
                'transform': 'translate(' + weekNumberWidth + ',' + weekDaysHeight + ')'
            });
        const weekDays = moment.weekdaysShort();

        weekDaysGroup
            .selectAll('text')
            .data(weekDays)
            .enter()
            .append('text')
            .attr({
                'transform': (d, i) => { return 'translate(' + ((i) * size) + ',' + 0 + ')'; }
            })
            .text(d => d);
        return size;
    }

    private initClock(container) {
        const selectionContainer = d3.select(container);
        const cc = selectionContainer.select('.clockContainer')[0];
        const divWidth = $(cc).width();
        const radius = Math.min(divWidth / 2, 75);
        const tickLength = 10;

        const arc = d3.svg.arc()
            .innerRadius(radius - 1)
            .outerRadius(radius);

        const clockGroup = selectionContainer.select('.clockContainer')
            .select('.clock')
            .append('svg')
            .append('g')
            .classed('clock', true)
            .attr({
                'transform': 'translate(' + (divWidth / 2) + ',' + (radius) + ')'
            });

        clockGroup.append('path')
            .classed('frame', true)
            .attr({
                'd': (d) => {
                    const path = arc.startAngle(0)
                        .endAngle(2 * Math.PI);
                    return path(d);
                }
            });

        const ticks = new Array(12);
        clockGroup.selectAll('line')
            .data(ticks)
            .enter()
            .append('line')
            .classed('clock-tick', true)
            .attr({
                'x1': (d, i) => { return radius * Math.cos(i * Math.PI / 6); },
                'y1': (d, i) => { return radius * Math.sin(i * Math.PI / 6); },
                'x2': (d, i) => { return (radius - tickLength) * Math.cos(i * Math.PI / 6); },
                'y2': (d, i) => { return (radius - tickLength) * Math.sin(i * Math.PI / 6); }
            });

        this._hourNeedle = clockGroup.append('g').classed('hour', true);
        this.scope.hourNeedle = this._hourNeedle;
        this._hourNeedle.append('line')
            .attr({
                'x1': 0,
                'y1': 2,
                'x2': 0,
                'y2': -(radius - 15),
            })
            .classed('needle', true);
        this._minuteNeedle = clockGroup.append('g').classed('minute', true);
        this.scope.minuteNeedle = this._minuteNeedle;
        this._minuteNeedle.append('line')
            .attr({
                'x1': 0,
                'y1': 5,
                'x2': 0,
                'y2': -(radius - 5),
            })
            .classed({ 'needle': true });

        clockGroup.append('circle')
            .attr({
                'cx': 0,
                'cy': 0,
                'r': 2
            });

    }
}